module.exports = __webpack_public_path__ + "static/img/WT.01a9ab2d.svg";